//
//
//

export default {
  props: {
    aspectRatio: {
      type: String,
      default: '1 / 1',
    },
    variant: {
      type: String,
      default: 'image',
    },
  },
  computed: {
    classList() {
      return {
        placeholder: true,
        ['placeholder--' + this.variant]: this.variant,
      }
    },
  },
}
